import {url} from './constants'

export const loadTranslationsRequ = (name) => {
    const fullUrl = url + '/' + name + '.json';

    return fetch(fullUrl).then(data => data.json());
};